import React, { useState, useEffect } from "react";
import SelectThemes from "./SelectThemes";
import MediaDisplay from "./MediaDisplay";


const ProfileViewSettings = () => {
  const [flashMessage, setFlashMessage] = useState("");
  const [profileSettings, setProfileSettings] = useState({
    feedViewMode: "singlepage",
    sortedOrder: "unsorted",
  });

  useEffect(() => {
    const loggedIn = JSON.parse(localStorage.getItem("userLoggedin"));
    const storedUsers = JSON.parse(localStorage.getItem("users")) || [];

    if (loggedIn && storedUsers.length > 0) {
      const currentUser = storedUsers.find(
        (u) =>
          u.userId === loggedIn.userId
      );

      if (currentUser) {
        setProfileSettings({
          feedViewMode: currentUser.feedViewMode || "singlepage",
          sortedOrder: currentUser.sortedOrder || "unsorted",
        });
      }
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    const loggedIn = JSON.parse(localStorage.getItem("userLoggedin"));
    let storedUsers = JSON.parse(localStorage.getItem("users")) || [];

    if (loggedIn && storedUsers.length > 0) {
      const userIndex = storedUsers.findIndex(
        (u) =>
          u.userId === loggedIn.userId
      );

      if (userIndex !== -1) {
        const user = storedUsers[userIndex];

        // Check if changes were made
        if (
          user.feedViewMode === profileSettings.feedViewMode &&
          user.sortedOrder === profileSettings.sortedOrder
        ) {
          setFlashMessage("⚡ No changes detected.");
          setTimeout(() => setFlashMessage(""), 2000);
          return;
        }

        // Update user settings
        storedUsers[userIndex] = {
          ...user,
          feedViewMode: profileSettings.feedViewMode,
          sortedOrder: profileSettings.sortedOrder,
        };

        // Save back to localStorage
        localStorage.setItem("users", JSON.stringify(storedUsers));

        setFlashMessage("✅ Settings updated!");
        setTimeout(() => setFlashMessage(""), 2000);
      }
    }
  };

  return (
    <div style={{ width: 1200, height: "auto", maxHeight: "1000vh", borderRadius: 20 }}>
      <div style={{ padding: "20px", background: "#222", color: "white", borderRadius: "8px", width: "300px" }}>
    <form onSubmit={handleSubmit}>
      {/* Feed View Mode */}
      <label style={{ display: "flex", flexDirection: "column", marginBottom: "10px", color: "white" }}>
        Feed View Mode
        <select
          value={profileSettings.feedViewMode}
          onChange={(e) =>
            setProfileSettings((prev) => ({ ...prev, feedViewMode: e.target.value }))
          }
          style={{
            marginTop: "5px",
            padding: "6px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            color: "black",
          }}
        >
          <option value="singlepage">Single Page</option>
          <option value="multipage">Multi Page</option>
        </select>
      </label>

      {/* Sorted Order */}
      <label style={{ display: "flex", flexDirection: "column", marginBottom: "10px" }}>
        Sorted Order
        <select
          value={profileSettings.sortedOrder}
          onChange={(e) =>
            setProfileSettings((prev) => ({ ...prev, sortedOrder: e.target.value }))
          }
          style={{
            marginTop: "5px",
            padding: "6px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            color: "black"
          }}
        >
          <option value="unsorted" style={{color: "black"}}>Unsorted Timeline</option>
          <option value="sorted" style={{color: "black"}}>Sorted Timeline</option>
        </select>
      </label>

      {/* Submit Button */}
      <button
        type="submit"
        style={{
          marginTop: "10px",
          padding: "6px 12px",
          background: "#4CAF50",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        Save Settings
      </button>

      {/* Flash Message */}
      {flashMessage && (
        <div
          style={{
            marginTop: "10px",
            padding: "8px",
            background: "#333",
            color: "#4CAF50",
            borderRadius: "4px",
          }}
        >
          {flashMessage}
        </div>
      )}
    </form>
    </div>

      <div style={{ display: "flex", flexDirection: "row" }}>
        <div style={{ width: 600, height: "100%" }}>
          <SelectThemes />
        </div>
        <div style={{ width: 600, height: "100%" }}>
          <MediaDisplay />
        </div>
      </div>
    </div>
  );
};

export default ProfileViewSettings;
